export default __webpack_public_path__ + "src/assets/icn-fee.ca855a2ed60e25b8ffacd87fc39a862b.svg";